import { ApiError } from "../../api";

export function spaPageLoadErrorMessage(err: unknown): string {
  if (err instanceof ApiError && err.message === "modbus_view_window_expired") {
    return "This fullscreen device view expired after one hour. Open View again from the device page.";
  }
  return err instanceof Error ? err.message : "Cannot load page";
}
